var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviousArrow = function SvgPreviousArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5673E",
    d: "M13.312 9.177 2.037 15.628C.944 16.253-.34 15.174.09 13.99L2.254 8 .09 2.01C-.34.824.944-.253 2.037.372l11.275 6.452c.913.52.91 1.833 0 2.353"
  })));
};
export { SvgPreviousArrow as ReactComponent };
export default "/_next/static/media/static/media/previous_arrow.b72fcbd4f0c1fbf4e014668552226672svg";